export const TODAY = 'Today';
export const TOMORROW = 'Tomorrow';
export const TIME_LAPSED = 'time-lapsed';
export const DAY_LAPSED = 'day-lapsed';
